import { css } from "@emotion/css"

export const agencyClientStyles = {
  textButton: css`
    --btn-padding: var(--spacing-m) 0 8px;
    --btn-min-width: 0;
    --btn-line-height: 1;
    --btn-color: inherit;
    --btn-font-weight: normal;
    --btn-bg-hover: transparent;
    --btn-bg-active: transparent;
    --btn-border-color-hover: transparent;
    --btn-bg-focus-ring-color: transparent;
    width: fit-content;
    &:focus {
      box-shadow: none;
    }
  `,
  selectIcon: css`
    width: 18px;
    height: var(--spacing-xl);
  `,
  phoneInput: css`
    width: 290px;
  `,
  number: css`
    width: 195px;
  `,
  extension: css`
    width: 100px;
    margin-left: var(--spacing-m);
  `,
  inputsWrapper: css`
    display: flex;
    justify-content: space-between;
  `,
  fieldWidth: css`
    width: 255px;
  `,
  codeTextfield: css`
    width: 158px;
  `,
  fieldWidthWider: css`
    width: 485px;
  `,
  fieldWidthWider2: css`
    width: 685px;
  `,
  zip: css`
    width: 158px;
  `,
  titleInput: css`
    width: 192px;
    margin-right: var(--spacing-m);
  `,
  nameInput: css`
    width: 277px;
  `,
  terms: css`
    width: 780;
  `,
  radioGroup: css`
    display: flex;
    flex-direction: row;
    column-gap: 2rem;
  `,
  mailInput: css`
    width: 485px;
  `,
  deleteIcon: css`
    width: 24px;
    height: 24px;
    cursor: pointer;
    color: var(--grey);
  `,
  iconButton: css`
    &.MuiIconButton-root {
      margin-left: var(--spacing-s);
      margin-top: var(--spacing-xs);
    }
  `,
}
